import React, { useState, useEffect } from 'react'
import { IS_LOCAL, API_TARGET } from '../lib/devServer'

const AAM_URL = import.meta.env.VITE_ASSET_MANAGER_URL || 'http://localhost:8081'

/**
 * Floating badge showing connection status for both services:
 *   - convorcher  (materials, environments, WebSocket)
 *   - asset-manager  (characters, animations, audio, gestures, prefabs, blueprints)
 *
 * Rendered by App when running in local mode or ?debugserver=1.
 */
export function ConnectionStatus() {
  const [convStatus, setConvStatus] = useState('checking') // checking | online | offline
  const [aamStatus,  setAamStatus]  = useState('checking')

  useEffect(() => {
    async function check() {
      // Convorcher — probe /health directly (not via proxy) so a down server
      // doesn't generate Vite proxy error noise in the terminal.
      try {
        const res = await fetch(`${API_TARGET}/health`, { signal: AbortSignal.timeout(2000) })
        setConvStatus(res.ok ? 'online' : 'offline')
      } catch {
        setConvStatus('offline')
      }

      // Asset Manager — direct call
      try {
        const res = await fetch(`${AAM_URL}/health`, { signal: AbortSignal.timeout(2000) })
        setAamStatus(res.ok ? 'online' : 'offline')
      } catch {
        setAamStatus('offline')
      }
    }

    check()
    const id = setInterval(check, 5000)
    return () => clearInterval(id)
  }, [])

  const pill = (children) => (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 5,
      background: 'rgba(0,0,0,0.65)', border: '1px solid #333',
      borderRadius: 4, padding: '3px 7px', color: '#ccc',
      backdropFilter: 'blur(4px)', fontFamily: 'var(--m-mono)', fontSize: 10,
    }}>
      {children}
    </div>
  )

  const dot  = (st) => <span style={{ color: st === 'online' ? '#4f4' : st === 'offline' ? '#f44' : '#fa0', fontSize: 9 }}>⬤</span>
  const sep  = <span style={{ color: '#444' }}>|</span>
  const txt  = (st) => st === 'online' ? 'online' : st === 'offline' ? 'offline' : 'checking…'

  return (
    <div style={{
      position: 'absolute', top: 8, right: 8, zIndex: 9999,
      display: 'flex', flexDirection: 'column', gap: 4,
      pointerEvents: 'none',
    }}>
      {pill(<>
        {dot(convStatus)}
        <span style={{ color: '#7cf', fontWeight: 'bold' }}>convorcher</span>
        {sep}
        <span style={{ color: '#888' }}>{IS_LOCAL ? 'localhost:8080' : API_TARGET}</span>
        {sep}
        <span style={{ color: convStatus === 'online' ? '#4f4' : convStatus === 'offline' ? '#f44' : '#fa0' }}>{txt(convStatus)}</span>
      </>)}
      {pill(<>
        {dot(aamStatus)}
        <span style={{ color: '#adf', fontWeight: 'bold' }}>asset-manager</span>
        {sep}
        <span style={{ color: '#888' }}>{IS_LOCAL ? 'localhost:8081' : AAM_URL}</span>
        {sep}
        <span style={{ color: aamStatus === 'online' ? '#4f4' : aamStatus === 'offline' ? '#f44' : '#fa0' }}>
          {aamStatus === 'online' ? `online` : txt(aamStatus)}
        </span>
      </>)}
    </div>
  )
}
